import React from 'react';
import type { EntityCellProps } from '../../../../model/index.tsx';
import PublicVsPrivateSwitchCell from '../common/public-vs-private-switch-cell/index.tsx';
import PrivateCell from './private/view.tsx';
import PublicCell from './public/index.tsx';

const TitleCell = (props: EntityCellProps): React.JSX.Element => (
	<PublicVsPrivateSwitchCell {...props}>
		{({ isPrivate }) => (isPrivate ? <PrivateCell /> : <PublicCell {...props} />)}
	</PublicVsPrivateSwitchCell>
);

export default TitleCell;
